import DisplaySettingsContext from '@Contexts/DisplaySettings';
import { useEffect, useState } from 'react';

const DisplaySettings = ({ children }) => {
    const [contactsPageSize, setContactsPageSize] = useState<number>(
        parseInt(localStorage.getItem('contactsPageSize') || '50')
    );
    const [donationsPageSize, setDonationsPageSize] = useState<number>(
        parseInt(localStorage.getItem('donationsPageSize') || '50')
    );

    useEffect(() => {
        localStorage.setItem('contactsPageSize', contactsPageSize.toString());
    }, [contactsPageSize]);

    useEffect(() => {
        localStorage.setItem('donationsPageSize', donationsPageSize.toString());
    }, [donationsPageSize]);

    const contextData = {
        contactsPageSize,
        setContactsPageSize,
        donationsPageSize,
        setDonationsPageSize,
    };

    return (
        <DisplaySettingsContext.Provider value={contextData}>
            {children}
        </DisplaySettingsContext.Provider>
    );
};

export default DisplaySettings;
